// extracted by mini-css-extract-plugin
export var actionButton = "_s2-0";
export var actionMenuContainer = "_s2-i";
export var bubble = "_s2-2";
export var bubbleActionMenu = "_s2-j";
export var bubbleContext = "_s2-6";
export var bubbleItems = "_s2-7";
export var customer = "_s2-3";
export var divider = "_s2-8";
export var fileList = "_s2-9";
export var hiddenComment = "_s2-o";
export var infoAbove = "_s2-a";
export var internal = "_s2-4";
export var lightActionButton = "_s2-1";
export var link = "_s2-b";
export var merchant = "_s2-5";
export var message = "_s2-c";
export var profilePicture = "_s2-e";
export var quillToolbarContainer = "_s2-f";
export var senderDate = "_s2-g";
export var senderDateCustomer = "_s2-h";
export var senderName = "_s2-d";
export var time = "_s2-k";
export var uploadedImage = "_s2-l";
export var username = "_s2-m";
export var xsmall = "_s2-n";